import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import React from "react";
import RHFErrorMessage from "./RHFErrorMessage";

const propsToRTFMapper = ({
  required,
  min,
  max,
  pattern,
  minLength,
  maxLength,
  validate,
}) => {
  return { required, min, max, pattern, minLength, maxLength, validate };
};

export const RHFSelect = (props) => {
  const { register, errors, options, label, helperText } = props;

  return (
    <Stack>
      <FormControl fullWidth>
        <InputLabel>{label}</InputLabel>
        <Select
          {...{
            ...props,
            required: false,
            min: null,
            max: null,
            pattern: null,
          }}
          inputProps={{ ...register(props.name, propsToRTFMapper(props)) }}
        >
          {options &&
            options.map((option, index) => {
              return (
                <MenuItem value={option.value} key={index}>
                  {option.label || option.value}
                </MenuItem>
              );
            })}
        </Select>
      </FormControl>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
      <RHFErrorMessage errors={errors} name={props.name} />
    </Stack>
  );
};
